export default __webpack_public_path__ + "static/media/avatar-s-22.5283923e.jpg";